<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold"
          >update transporter truck</small
        >
      </legend>
      <div>
        <form @submit.prevent="truckUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="id" :value="Truck.id" />
              <div class="form-group">
                <label>Transporter</label>
                <select
                  class="form-control transporter_id"
                  :value="Truck.transporter_id"
                  required
                >
                  <option value>select Transporter</option>
                  <option
                    v-for="transporter in systemTransporters"
                    :value="transporter.id"
                    :key="transporter.id"
                  >
                    {{ transporter.transporter_name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Truck no</label>
                <input
                  type="text"
                  class="form-control truck_no"
                  :value="Truck.truck_no"
                  placeholder="truck number plate"
                />
              </div>
              <div class="form-group">
                <label>Truck chassis no</label>
                <input
                  type="text"
                  class="form-control truck_chassis"
                  :value="Truck.truck_chassis"
                  placeholder=""
                />
              </div>
              <div class="form-group">
                <label>Engine no</label>
                <input
                  type="text"
                  class="form-control truck_engine_no"
                  :value="Truck.truck_engine_no"
                  placeholder=""
                />
              </div>
              <div class="form-group">
                <label>Logbook name</label>
                <input
                  type="text"
                  class="form-control logbook_name"
                  :value="Truck.logbook_name"
                  placeholder=""
                />
              </div>
              
              <div class="form-group">
                <label>Truck price</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control truck_price"
                  :value="Truck.truck_price"
                />
              </div>
              <div class="form-group">
                <label>Clearing cost</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control clearing_cost"
                  :value="Truck.clearing_cost"
                />
              </div>
              <div class="form-group">
                <label>Repair/M Cost</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control rm_cost"
                  :value="Truck.rm_cost"
                />
              </div>
             
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Trailer no</label>
                <input
                  type="text"
                  class="form-control trailer_no"
                  :value="Truck.trailer_no"
                  placeholder="trailer number"
                />
              </div>
              
              <div class="form-group">
                <label>Trailer chassis no</label>
                <input
                  type="text"
                  class="form-control trailer_chassis"
                  :value="Truck.trailer_chassis"
                  placeholder=""
                />
              </div> 
              <div class="form-group">
                <label>Trailer Logbook name</label>
                <input
                  type="text"
                  class="form-control logbook_name_trailer"
                  placeholder="driving licence number"
                  :value="Truck.logbook_name_trailer"
                />
              </div>
              
              <div class="form-group">
                <label>Trailer price</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control trailer_price"
                  :value="Truck.trailer_price"
                />
              </div>
              <div class="form-group">
                <label>Total Cost</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control total_cost"
                  :value="Truck.total_cost"
                />
              </div>
              <div class="form-group">
                <label>Remark</label>
                <input
                  type="text"
                  class="form-control remark"
                  placeholder=""
                  :value="Truck.remark"
                  
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-flat updatingTruck btn-rounded"
          >
            <i class="fa fa-refresh"></i> update transporter truck
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat updatingTruckLoader btn-rounded"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i> please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import $ from "jquery";
export default {
  created() {
    if (this.$store.getters.Truck.length === 0) {
      router.push("/managetrucks");
    }
    this.loadTransporters();
  },
  computed: {
    ...mapGetters(["Truck", "systemTransporters"]),
  },
  methods: {
    ...mapActions(["truckUpdate", "loadTransporters"]),
  },
};
</script>
<style scoped>
.updatingTruckLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucks/updatetruck.vue